"use strict";

exports.__esModule = true;
exports.roundDownToScale = roundDownToScale;
/**
 * Rounds a number down to the nearest value on the scale
 * @param {number} number   input to round from
 * @param {number} scale    interval to round to
 * @returns {number}
 */
function roundDownToScale(number, scale) {
  if (scale <= 0) {
    throw RangeError("Invalid scale. Scale must be larger than zero (scale=" + scale + ").");
  }

  return Math.floor(number / scale) * scale;
}